<template>
  <div>
    <section class="section">
      <div class="container">
        <div class="content">
          <table class="table is-fullwidth">
            <thead>
            <tr>
              <th></th>
              <th>Informe</th>
              <th>Controles</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(info,index) in informes" :key="index">
              <td>
                <span class="subtitle is-3">{{ index + 1 }}</span>
              </td>
              <td>
                <a
                    v-show="!showformeditnameinforme(info, index)"
                    class="is-size-3"
                    @click="showeditnameinforme(info, index)"
                >{{ info.nombre }}</a>
                <div v-show="showformeditnameinforme(info, index)" class="field has-addons">
                  <div class="control is-expanded">
                    <input
                        v-model="info.nombre"
                        class="input is-medium"
                        type="text"
                        placeholder="Nombre"
                    />
                  </div>
                  <div class="control">
                    <a class="button is-info is-medium" @click="subecambionombre(info)">Cambiar</a>
                  </div>
                  <div class="control">
                    <a class="button is-light is-medium" @click="cancelnameinforme">Cancelar</a>
                  </div>
                </div>
              </td>
              <td class="has-text-centered">
                <button class="button is-danger"
                        v-if="tokenUser.admin"
                        @click="eliminar(info)">
                    <span data-tooltip="Eliminar" class="icon tooltip">
                      <i class="material-icons">delete_forever</i>
                    </span>
                </button>
                <router-link
                    v-if="tokenUser.admin"
                    :to="{ name: 'listviewfrsid', params: { id: info.id } }"
                    class="button is-info"
                >
                    <span data-tooltip="Mostrar" class="icon tooltip">
                      <i class="material-icons">chrome_reader_mode</i>
                    </span>
                </router-link>
                <router-link
                    v-if="tokenUser.admin"
                    :to="{ name: 'priorizationfrsid', params: { id: info.id } }"
                    class="button is-link"
                >
                    <span data-tooltip="Priorizar" class="icon tooltip">
                      <i class="material-icons">whatshot</i>
                    </span>
                </router-link>
                <button
                    class="button is-link"
                    @click="downloaddata([info.responses, info.nombre, info.dataAdmin])"
                >
                  <span data-tooltip="Descargar Datos" class="icon tooltip">
                    <i class="material-icons">cloud_download</i>
                  </span>
                </button>
                <button
                    v-if="tokenUser.admin"
                    class="button"
                    @click="principal(info)"
                    v-bind:class="classfavorito(info)"
                >
                  <span data-tooltip="Poner En Favorito" class="icon tooltip">
                    <i class="material-icons">star</i>
                  </span>
                </button>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import {mapState} from "vuex";
import apiServices from "@/services/yungol-services";
import functions from "@/helpers/functions";

const XLSX = require("xlsx");

export default {
  data() {
    return {
      informes: [],
      showforminf: {
        info: "",
        index: "",
      },
    };
  },
  computed: {
    ...mapState(["idtoken", "modalnotification", "tokenUser"]),
    resultnotification() {
      return this.modalnotification.result.aceptar;
    },
    filteredItems: function () {
      return functions.filterItems(this.search, this.plantillas, [
        {cod: "nombre"},
      ]);
    },
  },
  methods: {
    principal(info) {
      this.editprincipal(this, info);
    },
    classfavorito(info) {
      if (info.status === "principal") {
        return "is-warning";
      } else {
        return "is-light";
      }
    },
    subecambionombre(info) {
      this.editanombreInforme(this, info);
      this.showforminf.index = "";
      this.showforminf.info = "";
    },
    cancelnameinforme() {
      this.showforminf.index = "";
      this.showforminf.info = "";
    },
    showformeditnameinforme(info, index) {
      if (index === this.showforminf.index) {
        return true;
      } else {
        return false;
      }
    },
    showeditnameinforme(info, index) {
      this.showforminf.info = info;
      this.showforminf.index = index;
    },
    eliminar(inf) {
      this.$store.commit("changenotificationmodal", {
        info: {
          title: "¡Cuidado!",
          message: "¿Realmente desea eliminar el informe?",
          clase: "is-white",
          data: inf.id,
        },
      });
    },
    async editanombreInforme(_this, data) {
      let result;
      try {
        result = await apiServices.post(`/editnombreinformefrs`, data);
        this.informes.forEach(function (k) {
          if (k.id === result.data._id) {
            k.nombre = result.data.nombre;
          }
        });
      } catch (err) {
        console.log(err);
      }
    },
    async editprincipal(_this, data) {
      try {
        await apiServices.post(`/editprincipalfrs`, data);
        _this.traeInformes(_this);
      } catch (err) {
        console.log(err);
      }
    },
    async traeInformes(_this) {
      let result;
      try {
        result = await apiServices.get(`/frslist`);
        _this.informes = [];
        result.data.forEach((el) => {
          const d = {
            nombre: el.nombre,
            id: el._id,
            status: el.status,
            responses: el.agrupadoras,
            dataAdmin: el.data
          };
          _this.informes.push(d);
        });
      } catch (err) {
        console.log(err);
      }
    },
    async deleteInformes(_this, id) {
      try {
        await apiServices.delete(`/informefrs/${id}`);
        _this.traeInformes(_this);
      } catch (err) {
        console.log(err);
      }
    },
    widthCols(data) {
      let values = []
      //  Se recorre todos los datos
      for (let i = 0; i < data.length; i++) {
        let cont = 0;
        // Se recorre la informacion de un Dato
        for (const d in data[i]) {
          // Si es la primera iteracion arma el dato con el tamaño del campo y lo guarda la array values
          if (i === 0) {
            let w = {width: (String(data[i][d]).length + 2)}
            values.push(w)
          }
              //  Si no es la primera iteracion compara los datos nuevo con los valores del array values
          //  con el fin de extraer el numero mas grande
          else {
            let w = (String(data[i][d]).length + 2)
            if (values[cont].width < w) {
              values[cont].width = w;
            }
            cont++;
          }
        }
      }
      // Se valian los tamaños de los titulos para evitar corte de texto en el Excel
      let cont = 0;
      for (const key in data[0]) {
        let w = (String(key).length + 2)
        if (values[cont].width < w) {
          values[cont].width = w;
        }
        cont++;
      }

      //  Se devuelve values con el formato necesario para el tamaño de columnas del Excel
      return values
    },
    downloaddata(d) {
      if (d[0] || d[2]) {
        let dataFrs = []

        if (this.tokenUser.admin) {
          for (let i = 0; i < d[2]['grupos'].length; i++) {
            let nameG = d[2]['grupos'][i]
            let subsG = d[2][nameG]

            for (let j = 0; j < subsG.length; j++) {
              let subgrupo = {
                'Grupo': subsG[j]['Grupo'],
                'SubGrupo': subsG[j]['SubGrupo'],
                'Check1': subsG[j]['check'] ? "Verdadero" : "Falso",
                'Check2': subsG[j]['check2'] ? "Verdadero" : "Falso",
                'CountData': subsG[j]['countData']['sum']
              }
              dataFrs.push(subgrupo)
            }
          }
        } else {
          for (let i = 0; i < d[0]['original'].length; i++) {
            let nameO = d[0]['original'][i]
            let subsG = d[0][nameO]['SubGrupo']
            for (let j = 0; j < subsG.length; j++) {
              let subgrupo = {
                'Grupo': nameO,
                'SubGrupo': subsG[j]
              }
              dataFrs.push(subgrupo)
            }
          }
        }

        //  Asignamos la informacion necesaria a nuevas variables
        let name = "Datos Frs " + d[1];
        //  Se agrega la data al libro de excel
        var ws = XLSX.utils.json_to_sheet(dataFrs);

        //  Se configura el tamaño de cada columna
        const widths = this.widthCols(dataFrs);
        ws["!cols"] = widths

        //  Se crea el libro con la data agregada, se le da un nombre y finalizando se descarga
        var wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Datos Frs");
        var nombreArchivo = name + ".xlsx";
        XLSX.writeFile(wb, nombreArchivo);
      } else {
        this.$store.dispatch("notify", {
          message: `Error no hay datos para descargar`,
          type: "is-danger",
        });
      }
    },
  },
  created() {
    if (this.idtoken) {
      this.traeInformes(this);
    }
  },
  watch: {
    idtoken(nv, ov) {
      if (nv) {
        this.traeInformes(this);
      }
    },
    resultnotification(nv, ov) {
      if (nv) {
        this.deleteInformes(this, this.modalnotification.result.data);
      }
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/frs/Listfrs.vue